/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

export const createRandomValuesArray = (max, len) => {
    let arr = [];
    for (let i = 0; i < len; i++) arr.push(Math.floor(Math.random() * max))
    return arr;
}

export const createMatrix = (array, len) => {
    let arr = [];
    for (let i = 0; i < len; i++) arr.push(array)
    return arr;
}

export const createArrayRange = (from, to, array) => {
    let start = array.indexOf(from), end = array.indexOf(to);
    return array.slice(start, end + 1)
}
